import React from 'react';
import SupersetDashBoardPage from './SupersetDashboardPage';

export function DashBoardTabbedPage() {
  return (
    <div style={{
      margin: '-20px',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      <SupersetDashBoardPage />
    </div>
  );
}
